module.exports = __webpack_public_path__ + "img/close.adb83098.svg";